export default Object.freeze({
    NONE: 'none',
    REMOVE_AND_ERROR: 'removeAndError'
});
